import React, { Component } from 'react';
// import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
// import NewVenue from 'components/AddNewVenue/AddNewVenue';
import NewVenueV2 from 'components/AddNewVenue/AddNewVenueV2';
import { local_routes } from 'utils/Routes';
import { GoogleApiWrapper } from 'google-maps-react';
import axios from 'axios';
//import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
//import { user_entity_uuid, user_access_level, apiUrl, myHeaders_Autorized, location_api, venues_api, myHeaders_With_Cache_Control, HeaderConfig, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import { org_friendly_url, user_entity_uuid, user_access_level, apiUrl, myHeaders_With_Cache_Control } from "Api/Api";
// , myHeaders_Autorized, location_api, venues_api
import '../style.css';
//import _get from 'lodash/get';
//import Button from "components/Button/Button"; 
//import { async } from 'q';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";

let imgTempArr = [];
// let particularCityData=null;
let formExistingData=null
class CityVenue extends Component {
    constructor(props) {
        super(props)
        this.state = {
            venues_array: [],
            selected_venue_index: 0,
            loading: true,
            message: '',
            error_message: '',
            
            location_info: {}, // because we don't it yet! URL is city friendly URL instead of uuid
            /*
            venueValidate: false,
            loading: true,
            showComponent: false,
            showEditComponent: false,
            venueData: [],
            venue_uuid: null,
            // FormData
            validated: false,
            placeName: '',
            street: '',
            city: '',
            state: '',
            postal: '',
            phone: '',
            website: '',
            ticketSite: '',
            capacity: '',
            // Image data
            imgArr: [],
            locationId: '',
            venue_name: '(NONE)',
            nextBtnLoader: false,
            createVenueLoader: false,
            editVenueLoader: false,
            totalVenData: null,
            initialVenueName: null,
            initialVenueId: null,
            successFormData: 0,
            locationData:null,
            locationDataArr:[],
            location_uuid:'',
            formExistingData:null,
            particularCityData:null,
            venueStatus:false,
            editVenueStatus:false,
            VenuesuccessMsg:'',
            */
        };
        //this.onClickToggleAddUser = this.onClickToggleAddUser.bind(this);
        //this.onClickToggleEditUser =this.onClickToggleEditUser.bind(this);
        this.workspace_base_url = "";
        if (org_friendly_url) {
            this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
    }

    componentDidMount = async function () {
        
        await this.APICalls({});
    }

    APICalls = async (config) => {
        let new_state = {...this.state};
        
        let [venues_response,location_response] = await Promise.all([
            axios.get(`${apiUrl}locations/${this.props.match.params.friendly_url}/venues?do_recursive=true`, myHeaders_With_Cache_Control),
            axios.get(`${apiUrl}locations/${this.props.match.params.friendly_url}`, myHeaders_With_Cache_Control)
        ]);
        
        if (location_response.data) {
            new_state.location_info = location_response.data;
        }
        
        new_state.venues_array = venues_response.data;
        new_state.venues_array = new_state.venues_array.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
        
        // for channels, channel admin might not own the venue
        for (let venue_obj of new_state.venues_array) {
            let editable = false;
            if (user_access_level === 'admin') {
                editable = true;
            } else if (venue_obj.users && venue_obj.users.length > 0) {
                editable = venue_obj.users.some((item) => {
                    if (item.entity_uuid === user_entity_uuid && item.xref_data && item.xref_data.entity_owner_integer) {
                        return true;
                    }
                });
            }
            venue_obj.editable = editable;
        }

        new_state.venues_array.unshift({entity_uuid:'',entity_name:'(None)', editable: true });

        if (config.selected_venue_uuid) {
            // a little tricky because of sorting by name
            for (let i = 0; i < new_state.venues_array.length; i++) {
                if (new_state.venues_array[i].entity_uuid === config.selected_venue_uuid) {
                    new_state.selected_venue_index = i;
                }
            }
        } else {
            new_state.selected_venue_index = 0;
        }
        
        if (config.message) {
            new_state.message = config.message;
        } else {
            new_state.message = "";
        }
        if (config.error_message) {
            new_state.error_message = config.error_message;
        } else {
            new_state.error_message = "";
        }
        new_state.loading = false;
        
        this.setState( new_state );
    }

    onSaveVenue = async (venue_info) => {
        if (venue_info === false) {
            // cancel
            this.setState({
                message: '',
                error_message: 'Canceled',
                selected_venue_index: 0,
                showEditComponent: false
            });
            return;
        }
        
        this.setState({
            loading: true,
            showEditComponent: false
        });
        
        let message = "";
        let error_message = "";
        
        let tmp_venue_info = {...venue_info};
        tmp_venue_info.friendly_url = tmp_venue_info.entity_name.toLowerCase().replace(/ /g, "-");

        // if we have entity_uuid it would be blank...remove it
        delete tmp_venue_info.entity_uuid;
        
        if (venue_info.entity_uuid) {
            // EDIT / patch
            await axios.patch(`${apiUrl}venues/${venue_info.entity_uuid}`, tmp_venue_info);
            message = "Venue successfully edited";
        } else {
            // CREATE / post
            tmp_venue_info.locations = [{
                entity_uuid: this.state.location_info.entity_uuid
            }];
            
            let add_venue_response = await axios.post(`${apiUrl}venues`, tmp_venue_info);
            if (add_venue_response.data.entity_uuid) {
                venue_info.entity_uuid = add_venue_response.data.entity_uuid;
                message = "Venue successfully added";
            } else {
                // problem!
                venue_info.entity_uuid = "";
                error_message = "Problem adding venue";
            }
        }
        
        //this.APICalls({message,selected_venue_uuid:venue_info.entity_uuid});
        this.APICalls({message,error_message});
    }

    // For handling venue change
    venueChangeHandler = (event) => {
        console.log("WorkspaceVenues venueChangeHandler",event.target.value);
        this.setState({
            message: '',
            error_message: '',
            showEditComponent: (event.target.value !== '0'), // '(None)'
            selected_venue_index: parseInt(event.target.value)
        });
    }
    
    onClickShowAddVenue = () => {
        this.setState({
            message: '',
            error_message: '',
            showEditComponent: true,
            selected_venue_index: 0 // blank info except entity_name
        });
    }
    
    /*
    getVenueList = async (location_uuid) => {
        let locVenueDataRes = await axios.get(`${location_api}/${location_uuid}/venues`, myHeaders_With_Cache_Control);
        let tmp_venue_array = [];
        if (locVenueDataRes.data) {
            
            if (user_access_level !== 'admin') {
                // check if user is owner
                locVenueDataRes.data = locVenueDataRes.data.filter(venue => {
                    if (venue.users && venue.users.length > 0) {
                        venue.users = venue.users.filter(user => {
                            if (user.xref_data && user.xref_data.entity_owner_integer && user.xref_data.entity_owner_integer >= 1) {
                                if (user.entity_uuid === user_entity_uuid) {
                                    return true;
                                }
                            }
                            return false;
                        });
                        if (venue.users.length >= 1) {
                            return true;
                        }
                    }
                    return false;
                })
            }
            
            locVenueDataRes.data = locVenueDataRes.data.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
            locVenueDataRes.data.unshift({ entity_name: '(None)', entity_uuid: '' })
            tmp_venue_array = locVenueDataRes.data;
        }
        return tmp_venue_array;        
    }
    
    // Add New Venue Form Toggling
    onClickToggleAddUser() {
        this.setState({
            showComponent: !this.state.showComponent
        });
    }
    // Edit Existing Venue Form Toggling
    onClickToggleEditUser=async()=> {
        this.setState({
            showEditComponent: !this.state.showEditComponent
        });
    }
    // Get Venue images data
    onGetVenueImgData = (recData) => {
        imgTempArr.length = 20;
        imgTempArr.push(recData)
        this.setState({ imgArr: imgTempArr })
    }

    // onGetSubmitVenueData 
    onGetSubmitVenueData = (userData) => {
        let imgTempArr = [];
        this.arrBfr(imgTempArr, userData);
    }
    */
    
    /*
    // For create venue
    arrBfr = async (imgData, userData) => {
        const { location_uuid, venueStatus } = this.state;
        
        // eslint-disable-next-line
        const { locationId } = this.state;
        // formdata for post and patch api's
        let formData = {
            entity_name: userData.placeName,
            friendly_url: userData.placeName,
            street: userData.street,
            city_name: userData.city,
            state_province: userData.state,
            postal_code: userData.postal,
            country: userData.country,
            phone: userData.phone,
            website_url: userData.website,
            ticketing_url: userData.ticketSite,
            max_capacity: userData.capacity,
            description: userData.description,
            coordinates_lat: userData.lat,
            coordinates_lon: userData.lng,
            locations: [{ entity_uuid: locationId }],
        }
        // Venue API call
        //let imagesData = [];
        
        // if condition for Edit Venue
        if (this.state.venue_uuid && venueStatus === true) {
            this.setState({ editVenueLoader: true });
 
            
            await axios.patch(`${apiUrl}venues/${this.state.venue_uuid}`, formData, myHeaders_Autorized)
            this.renderVenueData(this.state.venue_uuid);
            
            //this.setState({ editVenueLoader: false, loading: false })
            //let venData = await axios.get(`${location_api}/${location_uuid}/venues`, myHeaders_With_Cache_Control)
            //venData.data = venData.data.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
            //venData.data.unshift({entity_name:'(None)',entity_uuid:''})
            //this.setState({ venue_name:'(None)',venueData: venData.data, loading: false, VenuesuccessMsg: "Venue succesfully updated", showEditComponent: false })
            
            let tmp_venue_array = await this.getVenueList(location_uuid);
            
            this.setState({
                venue_name:'(None)',
                venueData: tmp_venue_array,
                editVenueLoader: false,
                loading: false,
                VenuesuccessMsg: "Venue succesfully updated",
                showEditComponent: false
            })
            
        } else {
            // else condition for creation of Venue

            this.setState({ createVenueLoader: true, });
            
            formData.locations = [
                {
                    entity_uuid: location_uuid
                }
            ];
            //let venuePostData = await axios.post(`${venues_api}`, formData, myHeaders_Autorized);
            await axios.post(`${venues_api}`, formData, myHeaders_Autorized);
            
            let tmp_venue_array = await this.getVenueList(location_uuid);
            
            this.setState({
                venue_name: '(None)',
                venueData: tmp_venue_array,
                loading: false,
                createVenueLoader: false,
                VenuesuccessMsg: "Venue succesfully Created",
                showComponent: false,
                showEditComponent:false
            });
            
        }
    }

    // For handling venue change
    venueChangeHandler = async(event) => {
        this.setState({venueStatus:true})
        let existingId=null;
        const { venueData } = this.state;
        if (event.target.value !== "(None)") {
            venueData.forEach((item) => {
                if (item.entity_name === event.target.value) {
                    existingId = item.entity_uuid;
                    this.setState({ venueValidate: false, venue_uuid: item.entity_uuid, venue_name: item.entity_name, totalVenData: item })
                }
            })
            this.setState({ editVenueStatus: true,VenuesuccessMsg:""  })
            this.renderVenueData(existingId)
        }
        else  this.setState({ venue_name: event.target.value, showEditComponent: false }); 
    }

    renderVenueData=async (existingId)=>{
        const existing_venue_page = await axios.get(`${venues_api}/${existingId}`, myHeaders_With_Cache_Control)
            if (existing_venue_page && existing_venue_page.data) {
                this.setState({ particularCityData: existing_venue_page.data, showEditComponent: true, editVenueStatus: false, });
            }
    }

    handleSubmitDescriptionData=(e)=>{
        e.preventDefault();
    }
    */
    
    render() {
        //const { VenuesuccessMsg, venueData, loading,editVenueStatus, showComponent, venue_name,showEditComponent, venue_uuid ,particularCityData} = this.state;
        // eslint-disable-next-line
        if (this.state.loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            )
        }

            return (
                <div className="venue eventCreation">
 
                    {/* <Form onSubmit={this.handleSubmitDescriptionData}> */}
                    { (!this.state.showEditComponent || (this.state.showEditComponent && this.state.selected_venue_index !== 0)) &&
                        <Form.Row className="align-items-center">
                            <Form.Group as={Col} md="6" controlId="validationPkTitle" className="venueAlign" style={{marginTop: "20px"}}>
                                <span className="d-flex justify-content-between align-items-center">
                                    <Form.Label>Edit Existing Venue</Form.Label>
                                </span>
                                <Form.Control
                                    disabled={this.state.showEditComponent}
                                    as="select"
                                    value={this.state.selected_venue_index}
                                    onChange={this.venueChangeHandler}
                                >
                                    {
                                        this.state.venues_array.map((item,i) =>
                                            <option key={item.entity_uuid} value={i}>{item.entity_name} {item.editable ? "" : "(Not Editable)"}</option>
                                        )
                                    }
                                </Form.Control>
                            </Form.Group>
                        </Form.Row>
                    }
                    { this.state.message &&
                        <p style={{color:'green',fontSize:12}}>{this.state.message}</p>
                    }
                    { this.state.error_message &&
                        <p style={{color:'red',fontSize:12}}>{this.state.error_message}</p>
                    }
                    { !this.state.showEditComponent &&
                        <h6 onClick={this.onClickShowAddVenue}>+ Add New Venue</h6>
                    }
                    
                    {/* </Form> */}
                    { this.state.showEditComponent &&
                        <div style={{ paddingTop: "10px" }}>
                            
                                <NewVenueV2
                                    venue_info={this.state.venues_array[this.state.selected_venue_index]}
                                    onSaveVenue={this.onSaveVenue}
                                />
                            
                            
                        </div>
                    }
                </div>
            );
        
        /*
            return (
                <div className=" venue eventCreation">
                    {
                        this.state.venueValidate === true
                        ?
                        <p className="PKAudioError flex-center">Please Select a Venue</p>
                        :
                        null
                    }
                     
                    <Form onSubmit={this.handleSubmitDescriptionData}>
                        <Form.Row className="align-items-center">
                            <Form.Group as={Col} md="6" controlId="validationPkTitle" className="venueAlign" style={{marginTop: 50}}>
                                <span className="d-flex justify-content-between align-items-center">
                                    <Form.Label>Edit Existing Venue</Form.Label>
                                    
                                </span>
                                <Form.Control
                                    as="select"
                                    required
                                    value={venue_name}
                                    //defaultValue="Please Select a Venue"
                                    onChange={this.venueChangeHandler}
                                >
                                    {
                                        venueData.map((item,i) =>
                                            <option key={i} value={item.entity_name}>{item.entity_name}</option>
                                        )
                                    }
                                </Form.Control>
                            </Form.Group>

                        </Form.Row>
                           
                            <p style={{color:'red',fontSize:12}}>{VenuesuccessMsg}</p>

                        <div>
                            {showEditComponent && particularCityData && !editVenueStatus? 
                                <NewVenue
                                    editVenueLoader={this.state.editVenueLoader}
                                    submitVenueData={this.onGetSubmitVenueData}
                                    NewVenueData={this.onGetVenueImgData}
                                    locationFormData={this.getLocationFormData}
                                    // onClickFromRmUser={this.onClickToggleEditUser}
                                    formExistingData={formExistingData}
                                    existing_venue_page={particularCityData}
                                    existing_venue_uuid={venue_uuid}
                                />
                            : null}
                        </div>
                    </Form>
                    <Row>
                        <Col lg={12}>
                            <div>
                                <div >
                                    <div className="add-newVenue venueAlign">
                                        <div style={{ display: this.state.successFormData === 0 ? "none" : null }} className="Invalid-section">
                                            <p className="venueSuccessMsg">Venue Added</p>
                                        </div>

                                        <h6 onClick={this.onClickToggleAddUser}>+ Add New Venue</h6>
                                        {showComponent ?
                                            <NewVenue
                                                createVenueLoader={this.state.createVenueLoader}
                                                submitVenueData={this.onGetSubmitVenueData}
                                                NewVenueData={this.onGetVenueImgData}
                                                locationFormData={this.getLocationFormData}
                                                onClickFromRmUser={this.onClickToggleAddUser}
                                            />
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        */
    }
}
export default GoogleApiWrapper({
    apiKey: 'AIzaSyATS36RdvbWd9ESucCYIVvzqIxj3EFbQcg'
})(CityVenue);
